import TvanHandleApi from 'api/TvanHandleApi'
import ModalConfirm from 'general/components/Modal/ModalConfirm'
import ToastHelper from 'general/helpers/ToastHelper'
import { memo, useCallback, useEffect, useRef, useState } from 'react'
import { useFormik } from 'formik'
import DraggableModal from 'general/components/Modal/DragableModal/DraggableModal'
import { Typography } from 'antd'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import * as Yup from 'yup'
import { REGEX_TVAN_MESSAGE } from 'general/constants/AppRegex'
import CustomLabel from 'general/components/CustomLabel'
const ModalCompanyConfigs = ({
  modalsState,
  setModalsState,
  refetchListInvoice,
}) => {
  const [dataConfix, setDataConfix] = useState({
    configNullNameGood: modalsState?.value?.companyConfig?.configNullNameGood,
    companyId: modalsState?.value?.companyId,
  })

  useEffect(() => {
    if (modalsState?.show) {
      setDataConfix({
        configNullNameGood:
          modalsState?.value?.companyConfig?.configNullNameGood,
        companyId: modalsState?.value?.companyId,
      })
    }
  }, [modalsState?.show])

  const updateConfigCompany = async (dataConfix) => {
    // Your logic to move to send invoice goes here
    // For example, you can call an API endpoint to move to send invoice
    // await sendInvoiceToHandler(payload)
    try {
      const { result, message } =
        await TvanHandleApi.updateConfigCompany(dataConfix)
      if (result?.result === 'success') {
        ToastHelper.showSuccess('Cấu hình thành công')
        refetchListInvoice()
      } else {
        ToastHelper.error('Lỗi nội bộ máy chủ')
      }
    } catch (error) {
      console.error(
        'Occured error at moveToSendErrorHandler function: ' + error,
      )
    }
  }
  console.log('modalsState', modalsState)

  const updateMessageForm = useFormik({
    initialValues: {
      messageId: '',
    },
    validationSchema: Yup.object({
      messageId: Yup.string()
        .matches(REGEX_TVAN_MESSAGE, 'Mã thông điệp không hợp lệ, hãy thử lại!')
        .required('Mã thông điệp không được để trống'),
    }),
    onSubmit: async (values) => {
      // await updateMessage({
      //   invoiceId: tvanState.activeRow?.invoiceId,
      //   messageId: values.messageId.trim(),
      // })
    },
  })
  const thisModalRef = useRef()

  return (
    <>
      <ModalConfirm
        header="Cấu hình tên hàng hóa datalog petro nếu không nhập"
        content={
          <>
            <p>
              Nếu không cấu hình tên, đối tác tích hợp datalog Petro sẽ không
              nhập tên hóa đơn sẽ báo lỗi
            </p>
            <p>
              Nếu cấu hình, đối tác đối tác tích hợp datalog Petro sẽ sử dụng
              tên cấu hình làm tên của hàng hóa không nhập
            </p>

            <div className="w-100">
              <CustomLabel
                htmlFor="configNameGood"
                text="Tên hàng hóa cấu hình"
                width={'100%'}
                fontWeight={500}
              />
              <CustomAntInput
                borderRadius="sm"
                type="text"
                value={dataConfix?.configNullNameGood}
                inputProps={{
                  autoComplete: 'off',
                  name: 'configNameGood',
                  placeholder: 'Tên hàng hóa cấu hình',
                  value: dataConfix?.configNullNameGood ?? '',
                  // onBlur: (e) => {
                  //   const trimmedValue = e.target.value?.trim()
                  //   setDataConfix({
                  //     ...dataConfix,
                  //     configNullNameGood: trimmedValue,
                  //   })
                  // },
                  onChange: (e) => {
                    const trimmedValue = e.target.value?.trim()
                    setDataConfix({
                      ...dataConfix,
                      configNullNameGood: trimmedValue,
                    })
                  },
                }}
              />
            </div>
            <strong>Bạn vẫn muốn thực hiện?</strong>
          </>
        }
        show={modalsState.show}
        setShow={(status) => setModalsState({ ...modalsState, show: status })}
        handleConfirm={(e) => {
          updateConfigCompany(dataConfix)
          // e.preventDefault()
          // moveToSendErrorHandler({ invoiceId: tvanState.activeRow?.invoiceId })
          // setModalsState({ key: 'moveStatusModal', value: false })
        }}
      />
    </>
  )
}
export default memo(ModalCompanyConfigs)
